import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import { ReactComponent as Toggle } from "shared/assets/Eye.svg";
import "./style.scss";

const FloatLabel = ({
  children,
  label,
  value,
  errors,
  touched,
  setType,
  type,
}) => {
  const [focus, setFocus] = useState(false);
  const [toggle, setToggle] = useState(type !== "password");
  const labelClass =
    focus || (value && value.length !== 0) ? "label label-float" : "label";
  const types = {
    true: "text",
    false: "password",
  };
  useEffect(() => {
    setType(types[toggle]);
  }, [toggle]);

  return (
    <div
      className={`float--label--status ${errors && touched && "error-label"}`}
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}>
      {children}
      <label className={labelClass}>{label}</label>
      <small className={"input-errors"}>{errors}</small>
      {type === "password" && (
        <div
          className={"toggle"}
          onClick={() => {
            setToggle((_toggle) => !_toggle);
          }}>
          <Toggle />
        </div>
      )}
    </div>
  );
};

FloatLabel.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  value: PropTypes.array,
  errors: PropTypes.string,
  touched: PropTypes.bool,
  setType: PropTypes.func,
  type: PropTypes.string,
};

export default FloatLabel;
